import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { createEnvironmentReport, debugLog } from "~care/lib/utils/debug-utils";

export const useIsDebug = (options?: { withReport?: boolean }) => {
  const clientSearchParams = useSearchParams();

  const isDebug =
    clientSearchParams.get("isDebug") === "true" ||
    clientSearchParams.get("isDebug") === "1";

  useEffect(() => {
    if (isDebug && options?.withReport) {
      debugLog("DEBUG ENABLED");
      debugLog(
        "Client search params:",
        Object.fromEntries(clientSearchParams.entries()),
      );

      createEnvironmentReport({
        client: Object.fromEntries(clientSearchParams.entries()),
      });
    }
  }, [isDebug, clientSearchParams, options]);

  return { isDebug };
};
